export default __webpack_public_path__ + "static/4original-logo-parking-ef4170621474553d3cc94092016f2387.png";